import { useMantineTheme } from "@mantine/core";
import { ThemeTokens, themeTokens as baseTokens } from "./tokens";

export const useThemeTokens = (): ThemeTokens => {
  const theme = useMantineTheme();
  const tokens = theme.other?.tokens as ThemeTokens | undefined;
  return tokens || baseTokens;
};
